/**
 * Plans & Subscriptions Service
 *
 * API calls for plan listing, checkout, and plan changes.
 */

import { apiGet, apiPost } from './apiClient';
import type {
  PlansResponse,
  CheckoutPayload,
  CheckoutResponse,
  ChangePlanPayload,
  ChangePlanResponse,
  Invoice,
} from '@/types';

/**
 * Get available plans and current subscription.
 */
export function getPlans(): Promise<PlansResponse> {
  return apiGet<PlansResponse>('/api/me/plans');
}

/**
 * Create a new subscription (checkout).
 */
export function checkout(data: CheckoutPayload): Promise<CheckoutResponse> {
  return apiPost<CheckoutResponse>('/api/subscriptions/checkout', data);
}

/**
 * Change current subscription to a different plan.
 */
export function changePlan(data: ChangePlanPayload): Promise<ChangePlanResponse> {
  return apiPost<ChangePlanResponse>('/api/subscriptions/change', data);
}

/**
 * Get user's invoice history.
 */
export function getInvoices(): Promise<Invoice[]> {
  return apiGet<Invoice[]>('/api/me/invoices');
}

/**
 * Cancel current subscription.
 */
export interface CancelSubscriptionResponse {
  status: string;
  refunded: boolean;
  contactSupport?: boolean;
  accessUntil?: string;
  message: string;
}

export function cancelSubscription(data: { reason: string; feedback?: string }): Promise<CancelSubscriptionResponse> {
  return apiPost<CancelSubscriptionResponse>('/api/subscriptions/cancel', data);
}
